import type { KgInsight } from '@api/api/kg-insights';
import { Button } from '@design/components/button/Button';
import { FollowThemeButton } from '@terminal/components/follow-theme-button/FollowThemeButton';
import { WatchlistTrigger } from '@terminal/components/watchlist/watchlist-trigger/WatchlistTrigger';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import styles from './KgInsightPreview.module.scss';

export type KgInsightHeaderButtonProps = {
  subject: KgInsight['subject'];
};

export const KgInsightHeaderButton = ({
  subject,
}: KgInsightHeaderButtonProps) => {
  const { t } = useTranslation(['insights', 'common']);

  if (subject.type === 'entity') {
    return (
      <WatchlistTrigger
        tag={subject.id}
        dropdownProps={{
          strategy: 'fixed',
          placement: 'bottom',
          inPortal: false,
        }}
        renderTrigger={isInWatchlist => (
          <Button
            className={clsx(styles.watchlistButton, {
              [styles.active]: isInWatchlist,
            })}
            data-testid="watchlist-button"
            label={
              isInWatchlist
                ? t('common:components.watchlistBtn.watching')
                : t('common:components.watchlistBtn.addToWatchlistLabel')
            }
            size="xsmall"
            variant="tertiary"
            iconName={isInWatchlist ? 'Checkmark' : 'Add'}
          />
        )}
      />
    );
  }

  if (subject.type === 'theme') {
    return <FollowThemeButton themeId={subject.id} />;
  }

  return null;
};
